import React from "react";

export type ProjectHeadingState = {
    left?: React.ReactNode;
    title?: string | React.ReactNode;
    right?: React.ReactNode;
    padded?: boolean;
};


export interface ProjectHeadingContextProps {
    heading: ProjectHeadingState;
    setHeading: (next: ProjectHeadingState) => void;
    clearHeading: () => void;
}

export const ProjectHeadingContext = React.createContext<ProjectHeadingContextProps | undefined>(undefined);